"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Screen", {
    enumerable: true,
    get: function() {
        return Screen;
    }
});
function Screen(_) {
    /* istanbul ignore next */ return null;
}

//# sourceMappingURL=Screen.js.map
